
        import '@folkjs/labs/standalone/folk-space-attribute';
        import '@folkjs/labs/standalone/folk-shape-attribute';
        import { FolkModalTool } from '@folkjs/labs/folk-modal-tool';
        FolkModalTool.define();
      